export const USER_ROLES = [
  { value: 1, label: 'Administrator' },
  { value: 2, label: 'Provider' },
  { value: 3, label: 'Clinical Staff' },
  { value: 4, label: 'Front Desk Staff' },
  { value: 5, label: 'Biller' },
];

export const LICENSE_TYPES = [
  { value: 'None', label: 'None' },
  { value: 'DEA', label: 'DEA' },
];

export const LOCATION = [
  { id: '1', locationName: 'Loc1' },
  { id: '2', locationName: 'Loc2' },
  { id: '3', locationName: 'Loc3' },
];

export const SPECIALITY = [
  {
    member_type: 'M, NP, PA',
    label: 'Adult Reconstructive Orthopedics',
    value: '207XS0114X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Allergy',
    value: '207KA0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Allergy/Immunology',
    value: '207K00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Anesthesiology',
    value: '207L00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Cardiology',
    value: '207RC0000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Cardiovascular Surgery',
    value: '2086S0129X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Colon and Rectal Surgery',
    value: '208C00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Critical Care',
    value: '207RC0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Dentistry',
    value: '122300000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Dermatology',
    value: '207N00000X',
  },
  {
    member_type: 'M',
    label: 'Diagnostic Radiology',
    value: '2085R0202X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Emergency Medicine',
    value: '207P00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Endocrinology',
    value: '207RE0101X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Endocrinology, Diabetes & Metabolism ',
    value: '207RE0101X',
  },
  {
    member_type: 'D',
    label: 'Endodontist',
    value: '1223E0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Family Practice',
    value: '207Q00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Foot and Ankle Orthopedics',
    value: '207XX0004X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Gastroenterology',
    value: '207RG0100X',
  },
  {
    member_type: 'D',
    label: 'General Dentistry',
    value: '1223G0001X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'General Practice',
    value: '208D00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Geriatric Medicine- IM',
    value: '207RG0300X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Gynecologic Oncology',
    value: '207VX0201X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Gynecology',
    value: '207VG0400X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Hematology',
    value: '207RH0000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Hematology/Oncology',
    value: '207RH0003X',
  },
  {
    member_type: 'M',
    label: 'Hospitalist',
    value: '208M00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Immunology',
    value: '246QI0000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Infectious Diseases',
    value: '207RI0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Infertility',
    value: '163WR1000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Internal Medicine',
    value: '207R00000X',
  },
  {
    member_type: 'M',
    label: 'Interventional Cardiology',
    value: '207RI0011X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Medical Oncology',
    value: '163WX0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Neonatology',
    value: '2080N0001X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Nephrology',
    value: '207RN0300X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Neurological Surgery',
    value: '207T00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Neurology',
    value: '2084N0400X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Nuclear Medicine',
    value: '207U00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Nutrition',
    value: '111NN1001X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Obstetrics',
    value: '207VX0000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Obstetrics/Gynecology',
    value: '207V00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Occupational Medicine',
    value: '2083X0100X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Ophthalmology',
    value: '207W00000X',
  },
  {
    member_type: 'M',
    label: 'Optometrist',
    value: '152W00000X',
  },
  {
    member_type: 'D',
    label: 'Oral and Maxillofacial Pathology',
    value: '1223P0106X',
  },
  {
    member_type: 'D',
    label: 'Oral Surgery',
    value: '1223S0112X',
  },
  {
    member_type: 'D',
    label: 'Orthodontics',
    value: '1223X0400X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Orthopedic Surgery',
    value: '207XP3100X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Otolaryngology',
    value: '207Y00000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pain Medicine',
    value: '207LP2900X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pathology',
    value: '207ZP0102X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pediatric Cardiology',
    value: '2080P0202X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pediatric Dermatology',
    value: '207NP0225X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pediatric Orthopedics',
    value: '207XP3100X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pediatrics',
    value: '208000000X',
  },
  {
    member_type: 'D',
    label: 'Pedodontist',
    value: '1223P0221X',
  },
  {
    member_type: 'D',
    label: 'Periodontics',
    value: '1223P0300X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Physical Medicine and Rehabilitation',
    value: '208100000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Plastic Surgery',
    value: '208200000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Podiatry',
    value: '213E00000X',
  },
  {
    member_type: 'D',
    label: 'Prosthodontist',
    value: '1223P0700X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Psychiatry',
    value: '2084P0800X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Pulmonary Medicine',
    value: '207RP1001X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Radiation Oncology',
    value: '2085R0001X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Radiology',
    value: '111NR0200X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Reproductive Endocrinology',
    value: '207VE0102X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Rheumatology',
    value: '207RR0500X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Spine Surgery',
    value: '207XS0117X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Sports Medicine',
    value: '207PS0010X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Sports Medicine- Orthopedics',
    value: '207PS0010X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Surgery, General',
    value: '208600000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Surgical Oncology',
    value: '2086X0206X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Urology',
    value: '208800000X',
  },
  {
    member_type: 'M, NP, PA',
    label: 'Vascular Surgery',
    value: '2086S0129X',
  },
];
